import { Observable } from 'rxjs/Observable';
import { IServerResponse, IConnectionStatus } from '@/app-modules/server-communications';

abstract class BaseResponse<T> {
  protected abstract filter(response: IServerResponse): boolean;

  protected abstract map(response: IServerResponse): T;

  public asStream(response$: Observable<IServerResponse>, error$: Observable<Error>, connectionStatus$: Observable<IConnectionStatus>): Observable<T> {
    return response$.switchMap((data) => Observable.of(data)
                    .filter(this.filter)
                    .map(this.map, this)
                    .catch((error) => {
                      // error$.next(error)
                      return Observable.empty<T>();
                    })).share();
  }
}

export { BaseResponse };



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/components/game/_domain/server/_base/base-response.ts